import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Paper, useTheme } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import Typography from "components/basic/typography";
import Button from "components/basic/button";

interface LockedOverlayProps {
  onSetAvailability: () => void;
}

const LockedOverlay: React.FC<LockedOverlayProps> = ({ onSetAvailability }) => {
  const theme = useTheme();
  const { t } = useTranslation("calendar");

  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(120, 120, 120, 0.35)",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          width: 420,
          maxWidth: "90%",
          p: 4,
          textAlign: "center",
          borderRadius: 2,
        }}
      >
        <WarningAmberRoundedIcon
          sx={{ fontSize: 44, color: theme.palette.warning.main, mb: 1 }}
        />
        <Typography variant="h4" style={{ fontWeight: 600, marginBottom: 8 }}>
          {t("locked.title")}
        </Typography>
        <Typography
          variant="body2"
          style={{
            color: theme.palette.text.secondary,
            marginBottom: theme.spacing(3),
          }}
        >
          {t("locked.body")}
        </Typography>
        <Button variant="contained" color="warning" onClick={onSetAvailability}>
          {t("locked.button")}
        </Button>
      </Paper>
    </Box>
  );
};

export default LockedOverlay;
